<template>
  <div>
    <!-- <v-row v-if="reviewedApplicants.length !== applicants.length"> -->
    <v-row v-if="jobPost.status == 'open'">
      <v-col cols="12" md="6" ref="videoDetailColumn">
        <h2>{{ jobPost.company.name }}</h2>
        <h3>{{ jobPost.position }}</h3>

        <ApplicantReview
          :applicant="this.currentApplicant"
          :queuedApplicantsLength="this.queuedApplicants.length"
          :jobPost="this.jobPost"
          v-if="this.currentApplicant"
        />
        <div v-else-if="this.applicants.length">
          All Candidates Reviewed. See Results
        </div>
        <div v-else>No candidates shortlisted for this role.</div>
      </v-col>

      <v-col>
        <div>
          <h2 class="mb-2">Up Next</h2>

          <div class="d-flex">
            <v-progress-linear
              :value="applicantsReviewedPercentage"
              height="25"
              color="#1E1E1E"
              dark
            >
              <strong>{{ Math.round(applicantsReviewedPercentage) }}%</strong>
            </v-progress-linear>
          </div>
        </div>

        <v-row>
          <v-col v-if="queuedApplicants.length">
            <div
              v-for="applicant in queuedApplicants"
              v-bind:key="applicant.id"
            >
              <ApplicantTeaser
                :handleApplicantClick="handleApplicantClick"
                :isReviewed="false"
                :applicant="applicant"
              />
            </div>
          </v-col>

          <v-col v-if="reviewedApplicants.length">
            <div
              v-for="applicant in reviewedApplicants"
              v-bind:key="applicant.id"
            >
              <ApplicantTeaser
                :handleApplicantClick="handleApplicantClick"
                :isReviewed="true"
                :applicant="applicant"
              />
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <div v-if="jobPost.status == 'reviewed'">
      <v-col>
        <ApplicantsComplete :applicants="applicants" :jobPost="jobPost" />
      </v-col>
    </div>

    <div v-if="jobPost.status == 'complete'">
      <v-alert color="#0274b3" dark icon="mdi-checkbox-marked-circle" prominent>
        Thank you for participating with HRNG! A member of our team will be
        following up with you in the next 48 hours on next steps, if any.
      </v-alert>
    </div>
  </div>
</template>

<script>
import ApplicantTeaser from '@/components/CandidateReview/ApplicantTeaser';
import ApplicantReview from '@/components/CandidateReview/ApplicantReview';
import ApplicantsComplete from '@/components/CandidateReview/ApplicantsComplete';
import { mapGetters } from 'vuex';

export default {
  components: { ApplicantTeaser, ApplicantReview, ApplicantsComplete },
  data() {
    return {
      currentApplicant: this.jobPost.applicants.filter(
        (item) => !item.rating && item.shortlisted
      )[0],
      rating: null,
      feedback: '',
      isActive: false,
      valid: false,
      rules: {
        required: (value) => !!value || 'Required.',
        min: (v) => v.length >= 5 || 'Min 5 characters',
      },
    };
  },
  props: ['jobPost'],
  created() {
    if (this.getUserType !== 'recruiter') {
      this.$router.push('/');
    }
  },

  computed: {
    applicants() {
      return this.jobPost.applicants.filter((item) => item.shortlisted);
    },
    reviewedApplicants() {
      return this.applicants.filter((item) => item.rating);
    },

    // queued applicants
    queuedApplicants: {
      get: function () {
        return this.applicants.filter(
          (item) => !item.rating && item.id !== this.currentApplicant.id
        );
      },
    },

    applicantsReviewedPercentage() {
      return (this.reviewedApplicants.length / this.applicants.length) * 100;
    },
    ...mapGetters(['getUserType']),
  },
  methods: {
    inReviewApplicant(id) {
      if (id) {
        return this.applicants.filter((item) => item.id) === id;
      } else {
        return this.applicants.filter((item) => !item.rating)[0];
      }
    },
    disabledProgressClick() {
      console.log('test');
    },
    handleApplicantClick(applicant) {
      this.currentApplicant = applicant;
    },
  },
};
</script>

<style></style>
